<template>
  <section class="flex flex-col">
    <div v-for="(item, index) in titles" :key="index" class="my-3">
      <h3>
        {{
          $t("lean.ranking.attributes.title", {
            pt: item.title.pt,
            en: item.title.en,
          })
        }}
      </h3>
      <label class="text-justify"
        >•
        {{
          $t("lean.ranking.attributes.subtitle", {
            pt: item.subtitle.pt,
            en: item.subtitle.en,
          })
        }}</label
      >
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import titles from "@/utils/titles.utils";
export default defineComponent({
  data() {
    return {
      titles,
    };
  },
});
</script>
